module.exports = __webpack_public_path__ + "img/header-weddingRingsMen@2x.61a1608.jpg";